// extracted by mini-css-extract-plugin
export default {"CommentBox":"IssueCommentEditor-module__CommentBox--JfMp5"};